import type { ContactFormStep } from './useContactFormModal';
import type { User } from '#auth-utils';

import { EventBusKeys } from '~/core/helpers/symbols';

interface ExternalHandlerContext {
	isOpen: Ref<boolean>;
	currentStep: Ref<ContactFormStep>;
	isUserLoggedIn: ComputedRef<boolean>;
	user: ComputedRef<User | null>;
	goToOtpFormStep: (shouldSendCode?: boolean) => void;
	sendForm: () => Promise<void>;
	submitExternalForm: () => Promise<{
		success: boolean;
		step: ContactFormStep;
	}>;
	addEventSuccessMessage: () => void;
	addEventError: () => void;
}

export function useContactFormExternalHandler(context: ExternalHandlerContext) {
	const {
		isOpen,
		currentStep,
		isUserLoggedIn,
		user,
		goToOtpFormStep,
		sendForm,
		submitExternalForm,
		addEventSuccessMessage,
		addEventError
	} = context;

	// External form submission handler
	async function handleExternalFormSubmission() {
		const isUserPhoneAlreadyValidated: boolean = !!(
			user.value?.phoneNumber && user.value.hasCompletedRegistration
		);

		// Abrir modal se estiver fechada
		if (!isOpen.value) {
			isOpen.value = true;
			await nextTick();
		}

		// Usuário logado com telefone validado: pode criar lead diretamente
		if (isUserLoggedIn.value && isUserPhoneAlreadyValidated) {
			const result = await submitExternalForm();
			currentStep.value = result.step;

			// Triggerar eventos manualmente pois o step foi mudado diretamente
			await nextTick();
			if (result.success) {
				addEventSuccessMessage();
			} else {
				addEventError();
			}
		} else {
			// Usuário não logado ou sem telefone validado:
			// Usar sendForm() que faz todo o fluxo correto
			// (complete_social -> OTP -> lead ou otp -> lead)
			await sendForm();
		}
	}

	// Event-bus listener
	useEventBus<void>(EventBusKeys.openContactModalAtOtp).on(
		handleExternalFormSubmission
	);

	return {
		handleExternalFormSubmission
	};
}
